module.exports = __webpack_public_path__ + "static/media/img-mastercard.509422ef.jpg";